export default __webpack_public_path__ + "static/media/draft2.8e0eac6e.svg";